import React, { FC } from "react";
import { CompanySettings } from "./accounts/CompanySettings";
import { CompanySettingsSupplier } from "../supplier-activation/CompanySettingsSupplier";

const CompanySettingsSupplierPageWrapper: FC = () => {
  return (
    <>
      <div className="profile-wizard mr-3 ml-3 mt-0">
        <main className="main profile-wizard">
          <div className="container pt-2">
            <CompanySettingsSupplier />
          </div>
        </main>
      </div>
    </>
  );
};

export default CompanySettingsSupplierPageWrapper;
